<template>
    <v-container fluid style=""> 
    
     <v-row>
        <v-spacer></v-spacer>
        <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddFilter()"  >Añadir filtro</v-btn>
    </v-row>
    <v-row > 
       <v-data-table :disableFiltering="true" style="width:100%; margin: 0;"
             :headers="headers" :class="'row-pointer'"
             ref = "dataTable"
             :items="data" 
             :fixedHeader="true" 
             :height="tableHeight"
             @click:row="filter => onEditFilter(filter)"
         >
            <template v-slot:item.fields="{ item }">
                <span v-if="item.fields">{{ item.fields.join() }}</span>
                </template>
         </v-data-table>
      </v-row>

      <v-dialog v-model="editDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            Editar filtro
          </v-card-title>
          <v-card-text>
            <v-form ref="filterForm">
              <v-row style="width:100%; margin: 0;">
                <v-col cols="12">
                    <v-text-field
                        v-model="editFilter.label"
                        :label="'Label'" :rules="[validationRules.required]"
                        :hint="$t(editFilter.label)" persistent-hint
                        autocomplete="none"
                        max="300"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editFilter.source"
                        :label="'Source'" 
                        :items="filterSources"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editFilter.type"
                        :label="'Type'" 
                        :items="filterTypes"
                    />
                </v-col>
            </v-row>
            <v-row v-if="editFilter.source && editFilter.source=='select'" style="width:100%; margin: 0;">
                <v-form ref="choicesForm">
                     <v-row>
                    <v-spacer></v-spacer>
                    <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddChoice()"  >Añadir opción</v-btn>
                </v-row>
                <v-col cols="12" v-for="(item, index) in editFilter.choices" :key="index">
                    <v-row >
                            <v-col cols="5">
                            <v-text-field
                                v-model="item.key"
                                :label="'Key'" :rules="[validationRules.required]"
                                autocomplete="none"
                                max="300"
                            />
                        </v-col>
                        <v-col cols="5">
                            <v-text-field
                                v-model="item.value"
                                :label="'Value'" :rules="[validationRules.required]"
                                autocomplete="none"
                                max="300"
                            />
                        </v-col>
                        <v-col cols="2" >
                            <v-btn @click="onDeleteChoice(item)" class="mt-4" color="primary" dark v-bind="attrs" v-on="on" text>
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                </v-form>
            </v-row>
            </v-form>

            <v-form ref="fieldsForm">
                <v-row style="width:100%; margin: 0;">
                    <v-spacer></v-spacer>
                    <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddField()"  >Añadir campo</v-btn>
                </v-row>
                <v-row style="width:100%; margin: 0;">
                    <v-col cols="6" v-for="(item, index) in editFilter.fields" :key="index">
                        <v-row >
                                <v-col cols="9">
                                <v-text-field
                                    v-model="editFilter.fields[index]"
                                    :label="'Field'" :rules="[validationRules.required]"
                                    autocomplete="none"
                                    max="300"
                                />
                            </v-col>
                            <v-col cols="2" >
                                <v-btn @click="onDeleteField(item)" class="mt-4" color="primary" dark v-bind="attrs" v-on="on" text>
                                    <v-icon small>delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form> 

          </v-card-text> 
          <v-card-actions>
            <v-btn v-if="editedIndex>-1" color="#ff0000" @click="onDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="onCancelEdit()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
 
     </v-container>
 </template>
 
 <script> 
 
 import BaseModule from '../../../common/BaseModule.js'
 import { Constants } from '../../../common/Constants'

 export default {
   name: 'FilterEditor',
   mixins: [BaseModule],
   components: { 
    
   },
    props: ['filters'],
   
   data() {
       return {
         headers: [
                    { text: 'Label', value: 'label' },
                    { text: 'Type', value: 'type' },
                    { text: 'Source', value: 'source' },
                    { text: 'Fields', value: 'fields' },],
         data: [],
         editedIndex: -1,
         editFilter: {},
         tableHeight:300,
         filterTypes:[],
         filterSources:[],
         editDialog: false
       }
   }, mounted() {
        this.data = this.filters;
        this.filterSources = Constants.filterSources;
        this.filterTypes = Constants.filterTypes;
    },watch: {
       context: function() { 
        
      },
      filters: function(filters) { 
        this.data = filters;
    }
     },
    methods: { 
        onAddChoice() {
            if (!this.editFilter.choices) {
                this.editFilter.choices =  [];
            }
            this.editFilter.choices.push({key:'', value:''});
        },
        onDeleteChoice (item) {
            this.editFilter.choices.splice(this.editFilter.choices.indexOf(item), 1);
        },
        onAddFilter() {
            this.editedIndex = -1;
            this.editDialog=true;
            this.editFilter = { 
                fields: []
            };
        },
        onAddField() {
            if (!this.editFilter.fields) {
                this.editFilter.fields =  [];
            }
            this.editFilter.fields.push('');
        },
        onEditFilter(filter) {
            this.editedIndex = this.data.indexOf(filter);
            this.editDialog=true;
            this.editFilter =  Object.assign({}, filter);
        },
        onCancelEdit() {
            this.editDialog=false;
            this.editFilter = {};
        },
        onDelete () {
            this.data.splice(this.editedIndex, 1)
            this.editDialog=false;
            this.editFilter = {};
        },onDeleteField (item) {
            this.editFilter.fields.splice(this.editFilter.fields.indexOf(item), 1);
        },
        onSave() {
            if (!this.$refs.fieldsForm.validate() || !this.$refs.filterForm.validate()) {
					return;
			}

            if (this.editedIndex > -1) {
                Object.assign(this.data[this.editedIndex], this.editFilter)
            } else {
                this.data.push(this.editFilter)
            }

            this.editDialog=false;
            this.editFilter = {};
        }
    }
 };
 </script>
  